import { RiImageEditFill, RiDeleteBin5Fill, MdOutlineZoomOutMap } from "@icons";
import "./content.scss";
import { DeleteModal } from "@components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Dispatch, RootState } from "@store";
import { deleteContent } from "@api";
import { OfferEdit } from "../Edit/OfferEdit";

type Props = {
  data: any;
  isLoading: boolean;
  setIsLoading: Function;
  getData: Function;
};

export const ContentCard = ({
  data,
  isLoading,
  setIsLoading,
  getData,
}: Props) => {
  const dispatch = useDispatch<Dispatch>();
  const [isModalDelete, setIsModalDelete] = useState(false);
  const [isModalOfferEdit, setIsModalOfferEdit] = useState(false); 
  
  const userAccess = useSelector(
    (state: RootState) => state.User.userInfo?.role_name?.access_group_id
  );

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const result = await deleteContent(data?.content_id);
      if (result.success) {
        dispatch.UI.setAlert({
          message: result?.message ?? "Successfully deleted!",
          type: "Success",
        });
      }
    } catch (err: any) {
      dispatch.UI.setAlert({
        message: err ?? "Unable to delete!",
        type: "Error",
      });
    }
    handleClose();
  };

  const handleClose = () => {
    setIsLoading(true);
    setIsModalDelete(false);
    getData();
  };

  return (
    <>
      <div className="content-card">
        <img
          src={data?.image_path}
          alt={data?.filename}
          className="content-img"
        />
        <div className="content-menu">
          <div
            className="content-menu-container"
            onClick={() => setIsModalOfferEdit(true)}
          >
            <RiImageEditFill className="content-icons" />
          </div>
          
          <div
            className="content-menu-container"
            onClick={() => userAccess?.content_delete ? setIsModalDelete(true) : ""} 
          >
            <RiDeleteBin5Fill className={userAccess?.content_delete ? "content-icons" : "content-icons-disable"} />
          </div>
          <a href={data?.image_path} target="_blank">
            <div className="content-menu-container">
              <MdOutlineZoomOutMap className="content-icons" />
            </div>
          </a>
        </div>

        <DeleteModal
          title="Offer"
          modalOpen={isModalDelete}
          cancelEvent={() => setIsModalDelete(false)}
          clickEvent={handleDelete}
          loading={isLoading}
          okLabel="Delete"
          subtitle={data?.title}
        />

        {isModalOfferEdit && (
          <OfferEdit
            getData={getData}
            content_id={data?.content_id}
            setIsModalOfferEdit={setIsModalOfferEdit}
            isModalOfferEdit={isModalOfferEdit}
          />
        )}
      </div>
    </>
  );
};
